import React from 'react';
import { Heading, Text, Box, HStack, Alert, Icon } from '@medely/ui-kit';

export const QuestionAndAnswersInfo = ({ estimatedMinutes }: { estimatedMinutes: number }) => {
  return (
    <>
      <Heading size="m">Screening Questions</Heading>
      <Box py={2}>
        <Alert
          severity="info"
          title="Your answers will be reviewed by Medely's clinical team to determine
                eligibility to participate in our marketplace."
          description="Incomplete answers or those copied from another source will result in
              disqualification."
          hideCloseIcon
          showIcon={false}
        />
      </Box>
      <HStack gap={2} alignItems="center">
        <Icon name="clock" variant="custom" color="text.primary" />
        <Text size="m">Estimated time to complete: {estimatedMinutes} minutes</Text>
      </HStack>
    </>
  );
};
